import React, { useEffect, useState } from "react";
import AdminNavbar from "../../components/admin_navbar";
import AdminSideMenu from "../../components/admin_side_menu";
import BarChart from "../../components/bar_chart";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const Dashboard = () => {
  const navigate = useNavigate();

  const [invoicesCount, setInvoicesCount] = useState(0);
  const [creditNotesCount, setCreditNotesCount] = useState(0);
  const [customersCount, setCustomersCount] = useState(0);
  const [storesCount, setStoresCount] = useState(0);
  const [chartData, setChartData] = useState();

  const getDashboardAnalytics = async () => {
    var apiBaseURL = process.env.REACT_APP_API_BASE_URL;
    var accessToken = localStorage.getItem("strutspos_access_token");

    try {
      const res = await axios({
        url: apiBaseURL + "/analytics",
        headers: {
          "x-strutspos-token": accessToken,
          "x-strutspos-application": "user",
        },
        method: "GET",
      });

      let dashboardAnalytics = JSON.parse(JSON.stringify(res.data));
      setCreditNotesCount(dashboardAnalytics.total_credit_notes_count);
      setInvoicesCount(dashboardAnalytics.total_invoices_count);
      setCustomersCount(dashboardAnalytics.customers_count);
      setStoresCount(dashboardAnalytics.stores_count);

      let chartSummariesData = dashboardAnalytics.chart_summary;

      setChartData({
        labels: chartSummariesData.map((data) => data.month),
        datasets: [
          {
            label: "Total Sales",
            data: chartSummariesData.map((data) => data.total_sales),
          },
        ],
      });
    } catch (err) {
      console.error("getDashboardAnalytics err = " + err);
    }
  };

  useEffect(() => {
    let accessToken = localStorage.getItem("strutspos_access_token");
    if (!accessToken) {
      navigate("/");
    }

    window.scrollTo(0, 0);

    getDashboardAnalytics();
  }, [navigate]);

  return (
    <div className="modern-admin-layout">
      <AdminNavbar />

      <div className="admin-container">
        <div className="admin-sidebar">
          <AdminSideMenu />
        </div>

        <main className="admin-main-content">
          {/* Modern Dashboard Header */}
          <div className="dashboard-header-modern">
            <div className="dashboard-header-content">
              <h1 className="dashboard-title">Dashboard Overview</h1>
              <p className="dashboard-subtitle">
                Monitor your business performance and key metrics
              </p>
            </div>
          </div>

          {/* Modern Stats Grid */}
          <div className="modern-stats-grid">
            <Link to="/invoices" className="modern-stat-card primary">
              <div className="stat-card-header">
                <div className="stat-icon primary">
                  <span>📄</span>
                </div>
                <div className="stat-trend up">
                  <span>↗ +12.5%</span>
                </div>
              </div>
              <div className="stat-content">
                <div className="stat-value">
                  {invoicesCount.toLocaleString()}
                </div>
                <div className="stat-label">Total Invoices</div>
              </div>
            </Link>

            <Link to="/credit-notes" className="modern-stat-card success">
              <div className="stat-card-header">
                <div className="stat-icon success">
                  <span>📋</span>
                </div>
                <div className="stat-trend down">
                  <span>↘ -2.1%</span>
                </div>
              </div>
              <div className="stat-content">
                <div className="stat-value">
                  {creditNotesCount.toLocaleString()}
                </div>
                <div className="stat-label">Credit Notes</div>
              </div>
            </Link>

            <Link to="/stores" className="modern-stat-card info">
              <div className="stat-card-header">
                <div className="stat-icon info">
                  <span>🏪</span>
                </div>
                <div className="stat-trend up">
                  <span>↗ +5.0%</span>
                </div>
              </div>
              <div className="stat-content">
                <div className="stat-value">{storesCount.toLocaleString()}</div>
                <div className="stat-label">Active Stores</div>
              </div>
            </Link>

            <Link to="#" className="modern-stat-card warning">
              <div className="stat-card-header">
                <div className="stat-icon warning">
                  <span>👥</span>
                </div>
                <div className="stat-trend up">
                  <span>↗ +8.3%</span>
                </div>
              </div>
              <div className="stat-content">
                <div className="stat-value">
                  {customersCount.toLocaleString()}
                </div>
                <div className="stat-label">Total Customers</div>
              </div>
            </Link>
          </div>

          {/* Modern Chart Section */}
          <div className="modern-chart-section">
            <div className="chart-card-modern">
              <div className="chart-header-modern">
                <div>
                  <h3>Sales Analytics</h3>
                  <p>Monthly sales performance overview</p>
                </div>
                <div className="chart-controls">
                  <select className="chart-filter-modern">
                    <option>Last 6 months</option>
                    <option>Last 12 months</option>
                    <option>This year</option>
                  </select>
                </div>
              </div>
              <div className="chart-container-modern">
                {chartData && (
                  <BarChart
                    labels={chartData.labels}
                    datasets={chartData.datasets}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Quick Actions Section */}
          <div className="quick-actions-section">
            <h3>Quick Actions</h3>
            <div className="quick-actions-grid">
              <Link to="/invoices" className="quick-action-card">
                <div className="quick-action-icon">📄</div>
                <div className="quick-action-content">
                  <h4>View Invoices</h4>
                  <p>View all invoices</p>
                </div>
              </Link>
              <Link to="/credit-notes" className="quick-action-card">
                <div className="quick-action-icon">📋</div>
                <div className="quick-action-content">
                  <h4>Credit Notes</h4>
                  <p>Manage credit notes</p>
                </div>
              </Link>
              <Link to="/stores" className="quick-action-card">
                <div className="quick-action-icon">🏪</div>
                <div className="quick-action-content">
                  <h4>Store Management</h4>
                  <p>Configure stores</p>
                </div>
              </Link>
              <Link to="/analytics" className="quick-action-card">
                <div className="quick-action-icon">📊</div>
                <div className="quick-action-content">
                  <h4>Analytics</h4>
                  <p>View detailed reports</p>
                </div>
              </Link>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
